import { Link } from "react-router-dom";
import logo from "../../assets/images/logo/logo_white.png";

const FooterThree = () => {
  return (
    <footer className="footer bg-neutral-900 position-relative z-1">
      <img
        src="assets/images/shapes/shape2.png"
        alt=""
        className="shape five animation-scalation"
      />
      <img
        src="assets/images/shapes/shape6.png"
        alt=""
        className="shape one animation-scalation"
      />
      <div className="py-20">
        <div className="container container-two">
          <div className="row gy-5">
            <div
              className="col-lg-3 col-sm-6 col-xs-6"
              data-aos="fade-up"
              data-aos-duration={1200}
            >
              <div className="footer-item">
                <div
                  className="footer-item__logo mb-0"
                  data-aos="zoom-in-right"
                >
                  <Link href="/">
                    <img src={logo} alt="" />
                  </Link>
                </div>
                <p className="text-white mt-20" style={{ fontSize: "13px" }}>
                  At NPS, we hope to invoke in students a love of learning
                  through the development of the intellectual, emotional,
                  social, physical and creative potentials.
                </p>
              </div>
            </div>
            <div
              className="col-lg-2 col-sm-6 col-xs-6"
              data-aos="fade-up"
              data-aos-duration={400}
            >
              <div className="footer-item">
                <h4 className="footer-item__title fw-medium text-white mb-20">
                  Quick Link
                </h4>
                <ul className="footer-menu">
                  <li className="mb-10">
                    <Link
                      to="/gallery"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Gallery
                    </Link>
                  </li>
                  <li className="mb-10">
                    <Link
                      to="/average-school-day"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Average School Day
                    </Link>
                  </li>
                  <li className="mb-10">
                    <Link
                      to="/school-details"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      School Details
                    </Link>
                  </li>
                  <li className="mb-10">
                    <Link
                      to="/mandatory-public-disclosure"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Mandatory Public Disclosure
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="col-lg-2 col-sm-6 col-xs-6"
              data-aos="fade-up"
              data-aos-duration={600}
            >
              <div className="footer-item">
                <h4 className="footer-item__title fw-medium text-white mb-20">
                  Resources
                </h4>
                <ul className="footer-menu">
                  <li className="mb-10">
                    <Link
                      to="/career"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Career
                    </Link>
                  </li>
                  <li className="mb-10">
                    <a
                      href="/pdf/School_Policy.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      School Policies
                    </a>
                  </li>

                  <li className="mb-10">
                    <a
                      href="/pdf/Disaster_Management.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Disaster Management
                    </a>
                  </li>
                  {/* <li className="mb-10">
                    <Link
                      href="/blog"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Blog
                    </Link>
                  </li> */}
                  {/* <li className="mb-10">
                    <Link
                      to="/other-document"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Other Documents
                    </Link>
                  </li> */}
                </ul>
              </div>
            </div>

            <div
              className="col-lg-2 col-sm-6 col-xs-6"
              data-aos="fade-up"
              data-aos-duration={400}
            >
              <div className="footer-item">
                <h4 className="footer-item__title fw-medium text-white mb-20">
                  Policies
                </h4>
                <ul className="footer-menu">
                  <li className="mb-10">
                    <Link
                      to="/refund-policy"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Refund Policy
                    </Link>
                  </li>
                  <li className="mb-10">
                    <Link
                      to="/privacy-policy"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                  <li className="mb-10">
                    <Link
                      to="/terms-and-conditions"
                      className="text-white hover-text-main-600 hover-text-decoration-underline"
                    >
                      Terms and Conditions
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="col-lg-3 col-sm-6 col-xs-6"
              data-aos="fade-up"
              data-aos-duration={800}
            >
              <div className="footer-item">
                <h4 className="footer-item__title fw-medium text-white mb-20">
                  Contact Us
                </h4>
                <div className="flex-align gap-20 mb-14">
                  <span className="icon d-flex text-20 text-white">
                    <i className="ph ph-phone" />
                  </span>
                  <div className="">
                    <a
                      href="tel:+919731226002"
                      className="text-white d-block hover-text-main-600 mb-0"
                    >
                      +91-9731226002
                    </a>
                  </div>
                </div>
                <div className="flex-align gap-20 mb-14">
                  <span className="icon d-flex text-20 text-white">
                    <i className="ph ph-envelope-open" />
                  </span>
                  <div className="">
                    <a
                      href="mailto:info@npskudlu.com"
                      className="text-white d-block hover-text-main-600 mb-0"
                    >
                      info@npskudlu.com
                    </a>
                  </div>
                </div>
                <div className="flex-align gap-20 mb-0">
                  <span className="icon d-flex text-20 text-white">
                    <i className="ph ph-map-trifold" />
                  </span>
                  <div className="">
                    <span
                      className="text-white d-block mb-4"
                      style={{ fontSize: "13px" }}
                    >
                      148, Silver County Rd, Kudlu, Singasandra, Bengaluru,
                      Karnataka – 560068 India
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        {/* bottom Footer */}
        <div className="bottom-footer border-top border-dashed border-neutral-600 border-0 py-10">
          <div className="container container-two">
            <div className="bottom-footer__inner flex-between gap-16 flex-wrap">
              <p
                className="text-white text-line-1 fw-normal"
                data-aos="zoom-in"
                style={{ fontSize: "13px" }}
              >
                Copyright © 2026 <span className="fw-semibold">NPS, Kudlu</span>{" "}
                All Rights Reserved | Powered by{" "}
                <a href="https://octaloptimum.com/" target="_blank">
                  Octal Optimum
                </a>
              </p>
              <ul
                className="social-list flex-align gap-24"
                data-aos="zoom-in-left"
              >
                <li className="social-list__item">
                  <Link
                    href="https://www.facebook.com/NPSKudlu/"
                    target="_blank"
                    className="text-white text-2xl hover-text-main-two-600"
                  >
                    <i className="ph-bold ph-facebook-logo" />
                  </Link>
                </li>

                <li className="social-list__item">
                  <Link
                    href="https://www.instagram.com/nps_kudlu/"
                    target="_blank"
                    className="text-white text-2xl hover-text-main-two-600"
                  >
                    <i className="ph-bold ph-instagram-logo" />
                  </Link>
                </li>
                <li className="social-list__item">
                  <Link
                    href="https://www.youtube.com/@NPSKudlu"
                    target="_blank"
                    className="text-white text-2xl hover-text-main-two-600"
                  >
                    <i className="ph-bold ph-youtube-logo" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterThree;
